import { authorizeManageMission } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
export function canDenyVolunteers(userContext, { missionTypeId, status }) {
    const allowedStatuses = new Set(['deniedNotQualified', 'deniedRosterFull']);
    if (!authorizeManageMission(userContext.userState, missionTypeId)) {
        throw new AuthError('Unauthorized, user cannot deny volunteers');
    }
    if (!allowedStatuses.has(status)) {
        throw new AuthError('Participation status is incorrect');
    }
}
